import React from "react";
import Alert from "@mui/material/Alert";

const Alerts = ({
  iserror,
  iserrorShow,
  errorMessages,
  isSuccess,
  successMessages,
  iswarning,
  warningMessages,
}) => {
  return (
    <div>
      <div>
        {iserror && iserrorShow && (
          <Alert severity="error">
            {errorMessages.map((msg, i) => {
              return <div key={msg}>{msg}</div>;
            })}
          </Alert>
        )}
      </div>
      <div>
        {iserror === true && iserrorShow === undefined ? (
          <Alert severity="error">
            {errorMessages.map((msg, i) => {
              return <div key={msg}>{msg}</div>;
            })}
          </Alert>
        ) : (
          ""
        )}
      </div>
      <div>
        {isSuccess && (
          <Alert severity="success">
            {successMessages.map((msg, i) => {
              return <div key={msg}>{msg}</div>;
            })}
          </Alert>
        )}
      </div>
      <div>
        {iswarning && (
          <Alert severity="warning">
            {successMessages.map((msg, i) => {
              return <div key={msg}>{msg}</div>;
            })}
          </Alert>
        )}
      </div>
      <br />
    </div>
  );
};
export default Alerts;
